import React from 'react';
import CustomIcon from '../../CustomIcon/CustomIcon'

const LoadingOverlay = () => (
  <CustomIcon name="ChartLoading" width={40} height={40} />
);

export default LoadingOverlay;
